import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { useHasEcoModulationsFeatureAccess } from "~/hooks/useHasEcoModulationsFeatureAccess"
import { ProductsEcoModulationsTable } from "~/pages/Brand/Regulations/EcoModulations/ProductsEcoModulationsTable"

export const ProductsEcoModulationsWrapper = () => {
  const { t } = useTranslation("regulations")
  const hasEcoModulationsAccess = useHasEcoModulationsFeatureAccess()

  if (!hasEcoModulationsAccess) {
    return (
      <InfoBox
        title={t("notSubscribed.title")}
        message={t("notSubscribed.message")}
      />
    )
  }

  return (
    <HeaderControlsProvider>
      <ProductsEcoModulationsTable />
    </HeaderControlsProvider>
  )
}
